import Header from "../../structures/header/index";
import Footer from "../../structures/footer/index";
import "../../../assets/css/story.css";

const IMG_HERO =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuCDhFNzNpWwvOyjC79YQbr2Zpy0YDPjkKyAPxFRKFDsPYqoCm7zRzkZmS9Y4SmXlhk1XoXSZYYx0-FQL2zulAKR1Fwji7N7GTwfK6LsDCWR3Wt2K2r_5rWq0SmvbknFo4uwp3PQendH3pb5hBzu1SMfr7onmVmjJRD_X_7IGqlmtux_Z6Ryretu2OUQjBe239rPimD0qM5BRu2ujulsxEpsZWhRTmGpjKKjpcikQOuu_js3svTqcgTKg6srHV5_HvSDxJi3JUB07ScK";

const IMG_KEYBOARD =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuCyJflluyBtEBu_jdq21opT7952QAgMZy--9QRvnXaDWtf6Rx11EnXx6WPQnu5d0f3TdPWNmXUW1BH1WtfyXwmjdpvJ9zz595UCrbWlhsOMEn_7rKv3aJ9IE-5DQaB9u32--o9FEL7RM_LftTu1AQNR_1cgc5gK-qYGaZcvCDmbYYJguQmDu1E62d8raeSEINXx0yw2Hk-s1Ktc_TxIFO56hpAIvyrQcSEQ6g9SijUfhERtv-IDqaQk6PXopzSA5bAewg-qnxHjvuM3";
const IMG_DATA =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuAWYXsx-jt9p4JqavrPII0oG05_Iy15S6CjBCZZQUIjZ3yuro_klXk91Ew--pqppzFV2ZJhnHG_WwIH_7YC4240zyzI-23hTF9l0vptx5gmnFYp_qClM0U0eu87oIiJIsRnwtb65Rmd7UgJ3H7QQ0I4n0LhPVL7MrjO2eGQ1jCDwcA39xg8kPgx9wEQGdZMAyhfgE78R6gne6EEzj9R0YTvE0RpAULcyeUwttwIiLNuVilcXTT5HqRz87YQsmbz0TzsyL97sJ2EY7T1";
const IMG_SKETCH =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuBEQ6VXhmonJCBNEkmzwWrq2zmhIbInCsP4Siallrontw4P6NoOfm_nMP5S9FeJoWWuDrQne4d3d_mQVesMrAqpaYmDIWT2xeKACw-MO4h7QhxEx6U-7yNRWNFGlx4DwSanz71TLwloEGPiHiiBuk4TUdKpgoBPfpRUrlxLZfJbedFCDcqSUUnvStFffpRs2qAJ0-c2SC3XLV8zMX0w9WwTiSYsNXqoaO3i3WLOcCnuJibmUpkWq8JizWiDEwZWs9XUX7sFWk81gpVl";
const IMG_CONCRETE =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuCwvwsFsjPfSo1q8CeMxsrAPTjjsLqceCA9xWZQ0jIF0P5wUj6Y-SGE2TUTEOl__3WDGGFo1svWenSwe5bBzskQdELJHJ7FFKznAOw5DP57HruBCHxyL6cO0DXYmdXQAE0Zlrv96tCcY5wfiuHyjkA4k7h27byjTFlP0LFcGy4RWFwsR3qB8rWtMCWQ01Up4PvG1E2uWTr59F9bBcsFFA1x6wfnQI1HcOLaK8uVNM4332YiIULYYnnFMShIr2hBRgkIbIruMr6OQI2w";

const IMG_TL1 =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuBK5iB4d_ZVrWfu5phwchOjXJ5byL0nPJpkcAVsT1okXuHPl9UobtIlwczMFg6vyvPKymsfjUB9aSTSqxhDef9EVHZ89lAeF5JRh6AYj7dG3-ViUOfxQxVl-aoNNVHU7zBSQLwMhhXA6Bgq-BZWrXy3uuYQfX8wZtp4XqAlMpzEpu38YgGEAU7BAd88MlRmPZYpu6YuLwHY2uf18Jq6ckYujSwsH5be6tdIncA64CSw464zYRsjvxwSabkCQArCV5zIbRom3GKFtTCN";
const IMG_TL2 =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuA9PHMopWiUSuDMBHzF5ra1lPv8P8fuztkyrqN-t6DT61yX640bG0wgY2ZLPutx9kxdJye-fqW2QuEs4abG3FM5nktXhtrd1Rvcvwz4dVevHNJXs0bBu6Mk-P6qKCMD_OnPl64BH1oUFW7B-5dwRgA9r13w-6-eWDF83cjy90_UqLCsAKECB_4FXIYqobXggaV6x_h4-ccRrYRQnglpnotGmOTyu5ky2WiXHTuoa0NRaEH5xpERTKZ0FjGcYbBmQtLip48qBuL2JVo4";
const IMG_TL3 =
  "https://lh3.googleusercontent.com/aida-public/AB6AXuAluB9RoHCzwumBtkyh-OqbdJm7o-az1OO_o9tl0IaLdvRqqdGpDRlQvtxTT5eZxV7EFiWbRAbh4qNVVyz5dmtmM0K7xh6Uqz4YFF17OE8J1EM7reCskFT8qlbSOySIMcbPHIv9k5z-xoOYuERW-Hk0qpUjhgfoXHZqZfe2iWxKH3r5m0CqkzuKsUcsnWRxT1w0XdPxoOH-ovc5iofJAsSXXwkNlAELSOnBRT9yrfCEwz9B0kCbHmUEu4kEbjGU1O7Hs8yY_59mE_uj";

  
const milestones = [
  {
    year: "2024: Ideation",
    title: "Menemukan Arah Baru",
    desc: "Tahun 2024 menjadi titik awal lahirnya ide besar Codelune bagaimana teknologi dan desain dapat menyatu untuk menciptakan solusi digital yang lebih manusiawi dan berdampak. Di sinilah visi dan mimpi mulai dirumuskan, menandai babak baru perjalanan kami.",
    img: IMG_TL3,
    side: "left",
    dotColor: "st-dot--primary",
  },
  {
    year: "2025: Kolaborasi",
    title: "Meretas Jejak Bersama Kuliner",
    desc: "Memasuki 2025, Codelune mulai membangun kolaborasi dengan berbagai restoran dan pelaku industri kuliner. Kami percaya, digitalisasi UMKM dimulai dari kemitraan nyata membantu mereka bertransformasi dan bertumbuh di era digital.",
    img: IMG_TL2,
    side: "right",
    dotColor: "st-dot--tertiary",
  },
  {
    year: "2026: Dedikasi",
    title: "Bersama UMKM, Menuju Masa Depan",
    desc: "2026 menjadi tonggak berdirinya Codelune sebagai mitra strategis bagi UMKM dan pelaku usaha lokal. Kami hadir untuk memberdayakan, memberikan akses teknologi, dan mendampingi perjalanan digital mereka agar mampu bersaing di pasar yang lebih luas.",
    img: IMG_TL1,
    side: "left",
    dotColor: "st-dot--primary",
  },
];

export default function StoryPage() {
  return (
    <>
      <Header activePage="story" />

      <main className="st-main">

        {/* ══════════════════════════════
            HERO
        ══════════════════════════════ */}
        <header className="st-hero">
          <div className="st-container">
            <div className="st-hero__grid">

              {/* Left — copy */}
              <div className="st-hero__content">
                <span className="st-hero__badge">Our Origin</span>
                <h1 className="st-hero__title">
                  Menemukan 'Lune' dalam <br /> Kompleksitas 'Code'
                </h1>
                <p className="st-hero__desc">
                  Kami tidak memulai dengan business plan. Kami memulai dengan sebuah pertanyaan: Mengapa dunia digital terasa begitu terputus dari sentuhan craftsmanship manusia? Codelune lahir di jam jam sunyi antara tengah malam dan fajar waktu di mana bulan bersinar.
                </p>
              </div>

              {/* Right — image card */}
              <div className="st-hero__img-wrap">
                <div className="st-hero__img-card">
                  <img src={IMG_HERO} alt="Minimalist workspace at night" />
                  <div className="st-hero__img-overlay" />
                </div>
                <div className="st-hero__img-badge glass-panel">
                  <span className="st-hero__badge-num">01</span>
                  <p className="st-hero__badge-label">The Inspiration</p>
                </div>
              </div>

            </div>
          </div>
        </header>

        {/* ══════════════════════════════
            PHILOSOPHY
        ══════════════════════════════ */}
        <section className="st-philosophy">
          <div className="st-container">
            <div className="st-philosophy__grid">

              {/* Left — text */}
              <div className="st-philosophy__text">
                <h2 className="st-philosophy__title">Digital Craftsmanship</h2>
                <div className="st-philosophy__body">
                  <p>
                    Di awal perjalanan, code hanyalah alat. Namun semakin kami menyelami arsitektur sistem modern, kami sadar bahwa logika tanpa keindahan terasa hampa. Kami mulai memperlakukan setiap baris code layaknya goresan pahat pada obsidian.
                  </p>
                  <p>
                    "Lune" dalam nama kami melambangkan kualitas cahaya yang sulit ditangkap di tengah gelap momen ketika masalah kompleks berubah menjadi solusi yang jernih. Inilah clarity yang muncul dari kekacauan syntax dan data.
                  </p>
                </div>
                <div className="st-philosophy__rule" />
              </div>

              {/* Right — image mosaic */}
              <div className="st-philosophy__mosaic">
                <div className="st-mosaic__col st-mosaic__col--a">
                  <div className="st-mosaic__img st-mosaic__img--sq">
                    <img src={IMG_KEYBOARD} alt="Mechanical keyboard" />
                  </div>
                  <div className="st-mosaic__img st-mosaic__img--tall">
                    <img src={IMG_DATA} alt="Data flows" />
                  </div>
                </div>
                <div className="st-mosaic__col st-mosaic__col--b">
                  <div className="st-mosaic__img st-mosaic__img--tall">
                    <img src={IMG_SKETCH} alt="Architect sketching" />
                  </div>
                  <div className="st-mosaic__img st-mosaic__img--sq">
                    <img src={IMG_CONCRETE} alt="Concrete architecture" />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* ══════════════════════════════
            TIMELINE
        ══════════════════════════════ */}
        <section className="st-timeline">
          <div className="st-timeline__header">
            <h2 className="st-timeline__title">Jalur Presisi</h2>
            <p className="st-timeline__sub">Jejak Perjalanan Kami</p>
          </div>

          <div className="st-timeline__track">
            {/* vertical line */}
            <div className="st-timeline__line" aria-hidden="true" />

            {milestones.map((m) => (
              <div
                key={m.year}
                className={`st-milestone ${m.side === "right" ? "st-milestone--right" : ""}`}
              >
                {/* text side */}
                <div className={`st-milestone__text ${m.side === "left" ? "st-milestone__text--left" : "st-milestone__text--right"}`}>
                  <span className="st-milestone__year">{m.year}</span>
                  <h3 className="st-milestone__title">{m.title}</h3>
                  <p className="st-milestone__desc">{m.desc}</p>
                </div>

                {/* image side */}
                <div className={`st-milestone__img-wrap ${m.side === "left" ? "st-milestone__img-wrap--right" : "st-milestone__img-wrap--left"}`}>
                  <div className={`st-dot ${m.dotColor}`} />
                  <div className="st-milestone__img">
                    <img src={m.img} alt={m.title} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ══════════════════════════════
            VALUES — BENTO
        ══════════════════════════════ */}
        <section className="st-values">
          <div className="st-container">
            <h2 className="st-values__title">Prospek & Potensi Brand</h2>
            <div className="st-values__bento st-values__bento--prospect">
              {/* Scalable Brand */}
              <div className="st-vcard st-vcard--precision">
                <div className="st-vcard__content">
                  <h3 className="st-vcard__title">Scalable Brand</h3>
                  <p className="st-vcard__desc">Codelune Studio — layanan agency & konsultasi digital yang siap berkembang secara berkelanjutan.</p>
                </div>
              </div>
              {/* Labs */}
              <div className="st-vcard st-vcard--sm">
                <span className="material-symbols-outlined st-vcard__icon">science</span>
                <h3 className="st-vcard__title">Codelune Labs</h3>
                <p className="st-vcard__desc st-vcard__desc--sm">Divisi riset, eksperimen, dan inovasi teknologi.</p>
              </div>
              {/* Platform */}
              <div className="st-vcard st-vcard--sm">
                <span className="material-symbols-outlined st-vcard__icon">cloud</span>
                <h3 className="st-vcard__title">Codelune Platform</h3>
                <p className="st-vcard__desc st-vcard__desc--sm">Produk SaaS & digital tools masa depan.</p>
              </div>
              {/* Global Market */}
              <div className="st-vcard st-vcard--asymmetry">
                <div>
                  <h3 className="st-vcard__title">Pasar Global</h3>
                  <p className="st-vcard__desc st-vcard__desc--sm">Nama tidak terikat bahasa Indonesia — mudah masuk ke pasar internasional.</p>
                </div>
                <span className="material-symbols-outlined st-vcard__arrow">public</span>
              </div>
              {/* Digital Era */}
              <div className="st-vcard st-vcard--sm">
                <span className="material-symbols-outlined st-vcard__icon">auto_awesome</span>
                <h3 className="st-vcard__title">Era Digital</h3>
                <p className="st-vcard__desc st-vcard__desc--sm">Brand yang menggabungkan teknologi + estetika sangat diminati di era modern.</p>
              </div>
              {/* Premium Positioning */}
              <div className="st-vcard st-vcard--sm">
                <span className="material-symbols-outlined st-vcard__icon">star</span>
                <h3 className="st-vcard__title">Positioning Premium</h3>
                <p className="st-vcard__desc st-vcard__desc--sm">Dengan branding yang tepat, Codelune dapat diposisikan sebagai high-quality digital craftsmanship brand.</p>
              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
}